<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>
      <div class="bank" v-else>
          <div class="info">
            <div class="row-content">{{this.bankInfo.bankinfo}}</div>
            <div class="row-content">{{this.userInfo.name}}</div>
            <div class="row-content">{{this.bankInfo.bankid}}</div>
          </div>
      </div>
      <div class="tips">{{$t("setting.bind_bank_tip")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return;
      }
      this.$router.push({ path: "/BindCard" });
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container.page {
  min-height: 100vh;
  background: #000;
  box-sizing: border-box;
}
::v-deep .nav-bar {
  background: #000;
}
::v-deep .nav-bar .van-nav-bar__title {
  color: #c9a84c;
}
::v-deep .nav-bar:after {
  border-bottom-color: rgba(201, 168, 76, 0.35);
}

.wrapper {
  padding: 24px;
}
.wrapper .add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c9a84c;
  background-color: #141414;
  height: 250px;
  border-radius: 16px;
  border: 1px dashed rgba(201, 168, 76, 0.55);
}
.wrapper .add-card ::v-deep .van-icon {
  color: #c9a84c;
  font-size: 36px;
}
.wrapper .add-card span {
  margin-left: 10px;
  font-size: 30px;
  color: #c9a84c;
}
.wrapper .bank {
  background: #141414;
  border-radius: 16px;
  border: 1px solid rgba(201, 168, 76, 0.45);
  padding: 10px 28px;
}
.wrapper .bank .info {
  flex: 1;
  color: #c9a84c;
}
.wrapper .bank .info .row-content {
  margin: 30px 0;
  line-height: 1.4;
  font-size: 30px;
  color: #c9a84c;
}
.wrapper .tips {
  margin: 24px 8px 0;
  font-size: 25px;
  color: #979799;
  line-height: 1.5;
}
</style>
